import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const ENTRIES = [{
  name: 'María L.',
  city: 'Buenos Aires'
}, {
  name: 'Carlos R.',
  city: 'Córdoba'
}, {
  name: 'Luciana M.',
  city: 'Rosario'
}, {
  name: 'Fernando G.',
  city: 'Mendoza'
}, {
  name: 'Valentina S.',
  city: 'La Plata'
}, {
  name: 'Diego P.',
  city: 'Tucumán'
}, {
  name: 'Camila A.',
  city: 'Mar del Plata'
}, {
  name: 'Martín H.',
  city: 'Salta'
}, {
  name: 'Sofía D.',
  city: 'Santa Fe'
}, {
  name: 'Nicolás B.',
  city: 'Neuquén'
}, {
  name: 'Ana K.',
  city: 'Bahía Blanca'
}, {
  name: 'Pablo T.',
  city: 'Resistencia'
}, {
  name: 'Julieta F.',
  city: 'Posadas'
}, {
  name: 'Tomás V.',
  city: 'San Juan'
}, {
  name: 'Florencia C.',
  city: 'Paraná'
}];
const COLORS = ['bg-brand-cyan', 'bg-brand-gold', 'bg-green-500', 'bg-blue-500', 'bg-purple-500', 'bg-pink-500'];
type ToastState = 'initial' | 'showing' | 'hiding' | 'dismissed';
export function SocialProofToast() {
  const [toastState, setToastState] = useState<ToastState>('initial');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [timeAgo, setTimeAgo] = useState(15);
  const [avatarColor, setAvatarColor] = useState(COLORS[0]);
  useEffect(() => {
    if (toastState === 'dismissed') return;
    let timeoutId: NodeJS.Timeout;
    const runCycle = () => {
      if (toastState === 'initial') {
        // Initial delay of 5 seconds
        timeoutId = setTimeout(() => {
          setToastState('showing');
        }, 5000);
      } else if (toastState === 'showing') {
        // Show for 4 seconds
        timeoutId = setTimeout(() => {
          setToastState('hiding');
        }, 4000);
      } else if (toastState === 'hiding') {
        // Wait for hide animation (500ms) + random delay (3-5s) before next
        const nextDelay = 500 + Math.floor(Math.random() * (5000 - 3000 + 1)) + 3000;
        timeoutId = setTimeout(() => {
          // Update data for next show
          setCurrentIndex(prev => (prev + 1) % ENTRIES.length);
          setTimeAgo(Math.floor(Math.random() * 47) + 1);
          setAvatarColor(COLORS[Math.floor(Math.random() * COLORS.length)]);
          setToastState('showing');
        }, nextDelay);
      }
    };
    runCycle();
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [toastState]);
  if (toastState === 'dismissed') return null;
  const currentEntry = ENTRIES[currentIndex];
  const initial = currentEntry.name.charAt(0).toUpperCase();
  const isVisible = toastState === 'showing';
  return <div className={`fixed bottom-4 left-4 z-30 transition-all duration-500 ease-in-out ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-[120%] opacity-0'}`} data-id="element-195">
      <div className="relative bg-brand-card/95 backdrop-blur-sm border border-gray-700 rounded-xl shadow-2xl p-3 max-w-[280px] flex items-center gap-3 pr-8" data-id="element-196">
        {/* Close Button */}
        <button onClick={() => setToastState('dismissed')} className="absolute top-2 right-2 text-gray-500 hover:text-gray-300 transition-colors" aria-label="Cerrar notificación" data-id="element-197">
          <XIcon className="w-3.5 h-3.5" data-id="element-198" />
        </button>

        {/* Avatar */}
        <div className={`w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center text-white font-bold text-lg shadow-inner ${avatarColor}`} data-id="element-199">
          {initial}
        </div>

        {/* Content */}
        <div className="flex flex-col" data-id="element-200">
          <p className="text-white text-sm font-bold leading-tight" data-id="element-201">
            {currentEntry.name}{' '}
            <span className="font-normal text-gray-300" data-id="element-202">
              de {currentEntry.city}
            </span>
          </p>
          <div className="flex items-center gap-1 mt-0.5" data-id="element-203">
            <CheckCircleIcon className="w-3 h-3 text-brand-cyan" data-id="element-204" />
            <p className="text-brand-cyan text-xs font-medium" data-id="element-205">
              Se registró a la Masterclass
            </p>
          </div>
          <p className="text-gray-500 text-[10px] mt-0.5" data-id="element-206">
            Hace {timeAgo} minuto{timeAgo !== 1 ? 's' : ''}
          </p>
        </div>
      </div>
    </div>;
}